import { NotificationService } from '@sine/sine-ui-components';

const notificationService = new NotificationService();

export default notificationService;
export * from './notification.helpers';
